import angular from 'angular';
import $ from 'jquery';
import avatarModule from '../avatarModule';
/*
    Example usage:
    <div page-focus focus-gained="pageFocused(secondsIdle)"></div>

    Calls the function in focus-gained when the page regains focus.
    Used on the avatar page to trigger a reload if you return to the page after X amount of time.
*/
function pageFocus($log) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      focusGained: '&focusGained',
      focusLost: '&focusLost'
    },
    link(scope, element, attrs) {
      angular.element(document).ready(function() {
        let lastBlur = null;

        $(window).focus(function() {
          $log.debug('Window focus');
          const now = new Date().getTime();
          if (lastBlur !== null) {
            const secondsIdle = (now - lastBlur) / 1000;
            scope.secondsIdle = secondsIdle;
            scope.focusGained({ secondsIdle });
          }
        });

        $(window).blur(function() {
          $log.debug('Window blur');
          lastBlur = new Date().getTime();
          scope.focusLost();
        });
      });
    }
  };
}

avatarModule.directive('pageFocus', pageFocus);

export default pageFocus;
